import { render, staticRenderFns } from "./ProjectActorDialog.vue?vue&type=template&id=1c7b1601&scoped=true&"
import script from "./ProjectActorDialog.vue?vue&type=script&lang=js&"
export * from "./ProjectActorDialog.vue?vue&type=script&lang=js&"
import style0 from "./ProjectActorDialog.vue?vue&type=style&index=0&id=1c7b1601&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c7b1601",
  null
  
)

export default component.exports